/*
 * File: CalendarMain.tsx
 * Project: a-a
 * File Created: Tuesday, 5th August 2025 11:37:08 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 17th October 2025 9:55:51 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
// import { Box, Typography } from '@mui/material';
// import React from 'react';
// import zeplinColor from '../../../theme/Color';

// const CalendarMain = () => {
//   return (
//     <Box
//       sx={{
//         border: `1px solid ${zeplinColor.Neutral5}`,
//         borderTopLeftRadius: '14px',
//         borderTopRightRadius: '14px',
//         padding: '24px',
//       }}
//     >
//       <Typography variant='h6'>Calendar Main</Typography>
//     </Box>
//   );
// };

// export default CalendarMain;
/*
 * File: CalendarMain.tsx
 * Project: a-a
 * File Created: Tuesday, 5th August 2025 11:37:08 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 5th August 2025 11:44:09 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
/*
 * Enhanced CalendarMain with props from CalendarPanel
 */
import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import zeplinColor from '../../../../theme/Color';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import CalendarGrid from '../CalendarPanel/CalendarGrid/CalendarGrid';
import { CalendarService } from '../../../../service/calendar.service';
import { Utilities } from '../../../../utilities/utilities';
import { AuthService } from '../../../../service/auth.service';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';

//  Add dayjs plugins for week handling
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
interface CalendarMainProps {
  selectedDateRange?: {
    startDate: Dayjs;
    endDate: Dayjs;
  };
  selectedDate: dayjs.Dayjs | null;
}

const CalendarMain: React.FC<CalendarMainProps> = ({ selectedDate }) => {
  //  Default to current week if no range provided
  const isGoogleConnectedState =
    sessionStorage.getItem('isGoogleConnected') === 'true' ? true : false;
  const [isGoogleConnected, setIsGoogleConnected] = useState(isGoogleConnectedState);
  const [isZoomConnected, setIsZoomConnected] = useState(
    sessionStorage.getItem('isZoomConnected') === 'true',
  );
  const Email = sessionStorage.getItem('current-user') || '';
  const [prevEvents, setPrevEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [filter, setFilter] = useState(['']);
  const [msToken, setMsToken] = useState(
    sessionStorage.getItem('MSToken') === 'true' ? true : false,
  );
  const [events, setEvents] = useState<any[]>([]); // Replace 'any' with your event type
  const defaultRange = {
    startDate: dayjs().startOf('week'),
    endDate: dayjs().endOf('week'),
  };
  const getTimezoneDetails = () => {
    let timezoneData = {
      offset: '+5', // default fallback
      abbreviation: 'LOCAL',
      name: 'Local Time',
      source: 'default',
    };

    try {
      // Priority 1: Extract from Google Events
      if (events && events.length > 0) {
        const eventWithTimezone = events.find(
          (event) => (event.start && event.start.includes('+')) || event.start.includes('-'),
        );

        if (eventWithTimezone) {
          const eventTime = dayjs(eventWithTimezone.start);
          const offsetMinutes = eventTime.utcOffset();
          const offsetHours = offsetMinutes / 60;

          timezoneData = {
            offset: Utilities.formatGMTOffset(offsetHours),
            abbreviation: 'EVENT',
            name: 'Event Timezone',
            source: 'google-events',
          };

          console.log(' Timezone from Google Events:', {
            eventStart: eventWithTimezone.start,
            offsetHours,
            formatted: timezoneData.offset,
          });

          return timezoneData;
        }
      }

      // Priority 2: System timezone
      const systemOffset = dayjs().utcOffset() / 60;
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      timezoneData = {
        offset: Utilities.formatGMTOffset(systemOffset),
        abbreviation: 'EVENT',
        name: userTimezone,
        source: 'system',
      };

      console.log(' Timezone from System:', {
        userTimezone,
        systemOffset,
        formatted: timezoneData.offset,
      });
    } catch (error) {
      console.warn('Error calculating timezone, using default:', error);
    }

    return timezoneData;
  };

  //  Display format options
  const getTimezoneDisplayText = () => {
    const { offset, abbreviation, source } = getTimezoneDetails();
    return `GMT ${offset}`;
  };
  const calculateWeekRange = (date: Dayjs) => {
    // Get the start of week (Sunday) and end of week (Saturday)
    const startOfWeek = date.startOf('isoWeek'); // Sunday
    const endOfWeek = date.endOf('isoWeek'); // Saturday

    return {
      startDate: startOfWeek,
      endDate: endOfWeek,
    };
  };
  const baseDate = selectedDate || dayjs();

  const dateRange = calculateWeekRange(baseDate);

  // const fetchTokenandMSEvents = async (
  //   code: string = '',
  //   isExistingAccessTokenValid: boolean = false,
  // ) => {
  //   try {
  //     setLoading(true);
  //     const res = await AuthService.ms_team_events(code, Email, isExistingAccessTokenValid);
  //     // console.log(res?.meetings);
  //     sessionStorage.setItem('MSToken', 'true');
  //     if (res) {
  //       sessionStorage.setItem('meetings', JSON.stringify(res));
  //       setEvents(res.meetings);
  //     }
  //   } catch (err: any) {
  //     setError(err);
  //     setEvents((prev) => prev);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const googleEvents = async () => {
    try {
      setLoading(true);
      const res = await CalendarService.getGoogleEvents({
        month: (selectedDate?.month() || dayjs().month()) + 1,
        year: selectedDate?.year(),
      });
      console.log(res);
      setEvents((prev) => [...prev, ...res]);
      setPrevEvents((prev) => [...prev, ...res]);
    } catch (error) {
      console.error('Error fetching Google events:', error);
    } finally {
      setLoading(false);
    }
  };
  const zoomEvents = async () => {
    try {
      setLoading(true);
      const res = await CalendarService.getZoomEvents({
        month: (selectedDate?.month() || dayjs().month()) + 1,
        year: selectedDate?.year(),
      });
      console.log(res, 'Zoom');
      setEvents((prev) => [...prev, ...res]);
      setPrevEvents((prev) => [...prev, ...res]);
      // setEvents((prev) => [...prev, ...res]);
      // setPrevEvents((prev) => [...prev, ...res]);
    } catch (error) {
      console.error('Error fetching Zoom events:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const handleCustomStorageChange = (e: CustomEvent) => {
      console.log('Custom storage change detected:', e.detail);
      if (e.detail.key === 'isGoogleConnected') {
        setIsGoogleConnected(e.detail.value === 'true');
        e.detail.value === 'false' && setEvents((res) => res.filter((ev) => ev?.type !== 'Google'));
        e.detail.value === 'false' &&
          setPrevEvents((res) => res.filter((ev) => ev?.type !== 'Google'));
        console.log('isGoogleConnected changed:', e.detail.value === 'true');
      }
      if (e.detail.key === 'MSToken') {
        setMsToken(e.detail.value === 'true');
        e.detail.value !== 'false' && setEvents((prev) => [...prev, ...e?.detail?.data?.meetings]);
        e.detail.value !== 'false' &&
          setPrevEvents((prev) => [...prev, ...e?.detail?.data?.meetings]);
        e.detail.value === 'false' &&
          setEvents((res) => res.filter((ev) => !Object.keys(ev).includes('body')));
        e.detail.value === 'false' &&
          setPrevEvents((res) => res.filter((ev) => !Object.keys(ev).includes('body')));
        console.log('MSToken changed:', e.detail.value === 'true', e.detail.data);
      }
      if (e.detail.key === 'isZoomConnected') {
        // setIsZoomConnected(e.detail.value === 'true');
        // e.detail.value === 'false' &&
        //   setEvents((res) => res.filter((ev) => !Object.keys(ev).includes('description')));
        setIsZoomConnected(e.detail.value === 'true');
        // e.detail.value === 'true' && zoomEvents();
        e.detail.value === 'false' && setEvents((res) => res.filter((ev) => ev?.type !== 'Zoom'));
        e.detail.value === 'false' &&
          setPrevEvents((res) => res.filter((ev) => ev?.type !== 'Zoom'));
        console.log('isZoomConnected changed:', e.detail.value === 'true');
      }
    };

    // Add event listener
    window.addEventListener('eventConnected', handleCustomStorageChange as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('eventConnected', handleCustomStorageChange as EventListener);
    };
  }, []);
  useEffect(() => {
    const handleCustomSelectedTools = (e: CustomEvent) => {
      if (e.detail.key === 'Google Meet') {
        console.log(
          'Custom storage change detected:',
          e.detail,
          e.detail.value === 'true',
          prevEvents,
        );
        setFilter((res) =>
          e.detail.value === 'true'
            ? res.filter((f) => f !== 'Google Meet')
            : [...res, 'Google Meet'],
        );
        setEvents((res) =>
          e.detail.value === 'true'
            ? prevEvents
                .filter((ev) =>
                  filter.includes('MSTeams') ? !Object.keys(ev).includes('body') : true,
                )
                .filter((ev) => (filter.includes('Zoom') ? ev?.type !== 'Zoom' : true))
            : res.filter((ev) => ev?.type !== 'Google'),
        );
      }
      if (e.detail.key === 'MSTeams') {
        console.log(
          'Custom storage change detected:',
          e.detail,
          e.detail.value === 'true',
          prevEvents,
        );
        setFilter((res) =>
          e.detail.value === 'true' ? res.filter((f) => f !== 'MSTeams') : [...res, 'MSTeams'],
        );
        setEvents((res) =>
          e.detail.value === 'true'
            ? prevEvents
                .filter((ev) => (filter.includes('Google Meet') ? ev?.type !== 'Google' : true))
                .filter((ev) => (filter.includes('Zoom') ? ev?.type !== 'Zoom' : true))
            : res.filter((ev) => !Object.keys(ev).includes('body')),
        );
      }

      if (e.detail.key === 'Zoom') {
        console.log(
          'Custom storage change detected:',
          e.detail,
          e.detail.value === 'true',
          prevEvents,
        );
        setFilter((res) =>
          e.detail.value === 'true' ? res.filter((f) => f !== 'Zoom') : [...res, 'Zoom'],
        );
        setEvents((res) =>
          e.detail.value === 'true'
            ? prevEvents
                .filter((ev) => (filter.includes('Google Meet') ? ev?.type !== 'Google' : true))
                .filter((ev) =>
                  filter.includes('MSTeams') ? !Object.keys(ev).includes('body') : true,
                )
            : res.filter((ev) => ev?.type !== 'Zoom'),
        );
      }
    };

    // Add event listener
    window.addEventListener('eventSelected', handleCustomSelectedTools as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('eventSelected', handleCustomSelectedTools as EventListener);
    };
  }, [prevEvents, filter]);
  useEffect(() => {
    if (isGoogleConnected) {
      googleEvents();
    } else {
      setEvents([]);
    }
    if (isZoomConnected) {
      zoomEvents();
    }
  }, [isGoogleConnected, isZoomConnected, selectedDate?.month(), selectedDate?.year(), msToken]);
  console.log('Rendering CalendarMain with events:', events, prevEvents);
  return (
    <Box
      sx={{
        border: `1px solid ${zeplinColor.Neutral5}`,
        borderTopLeftRadius: '14px',
        borderTopRightRadius: '14px',
        backgroundColor: zeplinColor.Neutral1,
        height: { xs: 'calc(100vh - 300px)', xl: 'calc(100vh - 360px)' },
        overflowX: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      {/* <Box
        sx={{
          padding: '24px',
          borderBottom: `1px solid ${zeplinColor.Neutral5}`,
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <Typography variant='responsiveHeading3' sx={{ marginBottom: '4px' }}>
          Calendar View
        </Typography>
        <Typography variant='body2' color={zeplinColor.Neutral8}>
          {dateRange.startDate.format('MMM DD')} - {dateRange.endDate.format('MMM DD, YYYY')}
        </Typography>
        <Typography
          variant='caption'
          color={zeplinColor.Neutral8}
          sx={{ marginTop: '4px', display: 'block' }}
        >
          {events.length} event{events.length !== 1 ? 's' : ''} scheduled
        </Typography>
      </Box> */}

      {/* Calendar Grid */}
      <Box sx={{ flex: 1, overflowX: 'auto' }}>
        <CalendarGrid
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          selectedDate={selectedDate}
          events={events}
          timeSlotHeight={60}
          startHour={0} // Start at 12 AM
          endHour={23} // End at 11 PM
          getTimezoneDisplayText={getTimezoneDisplayText}
        />
      </Box>
      <CustomAlert
        open={loading ? true : false}
        handleClose={() => {
          setLoading(false);
        }}
        message={
          <CustomAlertContain
            alertIcon={<CircularProgress sx={{ color: zeplinColor.Neutral1 }} size={'18px'} />}
            alert={loading ? `Connecting...` : ''}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default CalendarMain;
